import React from 'react'
import get from 'lodash/get'
import set from 'lodash/set'
import findIndex from 'lodash/findIndex'
import startsWith from 'lodash/startsWith'
import find from 'lodash/find'
import clone from 'lodash/clone'
import uniqBy from 'lodash/uniqBy'
import filter from 'lodash/filter'

import moment from '../../../lib/moment.js'
import Searchbar from '../searchbar/searchbar-resource-cost'
import ResourceCostTable from '../table/table-resource-cost'
import { AutoFillManDaysForm, AddResourceForm, ConfirmSaveForm } from '../form'
import { addButton } from '../helper/button'
import * as CONSTANTS from '../constants'

export default class ResourceCostTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'resources', get(projectByID, 'resources', []))
      set(tempState, '$resource_cost', projectByID.$resource_cost)
      set(tempState, '$work_days', projectByID.$work_days)
      set(tempState, 'auto_fill_start_date', moment(get(projectByID, 'start_date')))
      set(tempState, 'auto_fill_end_date', moment(get(projectByID, 'end_date')))
      set(tempState, 'override_total_resource_mandays', projectByID.override_total_resource_mandays)
      set(tempState, 'override_avg_resource_man_day_rate', projectByID.override_avg_resource_man_day_rate)
      set(tempState, 'override_total_resource_cost', projectByID.override_total_resource_cost)
      set(tempState, 'override_total_resource_price', projectByID.override_total_resource_price)
    }
    if (get(nextProps, 'editResource') !== get(prevState, 'editResource')) {
      set(tempState, 'editResource', get(nextProps, 'editResource'))
    }
    return tempState
  }

  state={
    hide: false,
    editResource: false,
    showAutoAdd: false,
    showConfirmSave: false,
    showAddSubCon: false,
    showAddEmployee: false,
    search_resource: '',
    filter_lob: [],
    filter_module: [],
    resources: [],

    resource_user_id: [],
    resource_search: '',

    override_total_resource_mandays: 0,
    override_avg_resource_man_day_rate: 0,
    override_total_resource_cost: 0,
    override_total_resource_price: 0,

    auto_fill_man_days: [],
    auto_fill_search: '',
    auto_fill_start_date: moment(),
    auto_fill_end_date: moment(),
    maximum_working_day: true,
    specific_working_day: false,
    working_day: 0,
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  clickCalculate = () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    const payload = { ...this.state.projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.workDays
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload.can_edit
    delete payload._id
    delete payload.updated_by
    payload.resources = this.state.resources
    editProjectInformation(payload, false)
  }

  editResourceCost = () => {
    const showConfirm = get(this.props, 'showConfirm')
    let invalid = false
    const resources = { ...this.state.resources }
    for (let i = 0; i < resources.length; i++) {
      invalid = (resources[i].man_days).filter((element) => element.days > 31).length > 0
      if (invalid) {
        showConfirm('errorEditResource', 'Error', 'You have some invalid information. Please check and edit.')
        return
      } if (resources[i].type === 'Subcontract') invalid = resources[i].cost_rate <= 0 || resources[i].price_rate <= 0
      if (invalid) {
        showConfirm('errorEditResource', 'Error', 'You have some invalid information. Please check and edit.')
        return
      }
    }
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
  }

  resetProject = () => this.setState({ projectByID: null })

  autoFillMandays = () => {
    if (this.state.auto_fill_start_date === null
      || this.state.auto_fill_end_date === null
      || this.state.working_day > 31) return
    const auto_fill_payload = {}
    auto_fill_payload.start_month = this.state.auto_fill_start_date.format('YYYY-MM-DD')
    auto_fill_payload.end_month = this.state.auto_fill_end_date.format('YYYY-MM-DD')
    auto_fill_payload.days = parseFloat(this.state.working_day)
    auto_fill_payload.maximum = this.state.maximum_working_day
    auto_fill_payload.array_user_id = this.state.auto_fill_man_days
    const project = { ...this.state.projectByID }
    const resources = []
    this.state.resources.map((r) => {
      const resource = {}
      resource.user_id = r.user_id
      resource.role = r.role
      resource.type = r.type
      resource.cost_rate = parseFloat(r.cost_rate)
      resource.price_rate = parseFloat(r.price_rate)
      const man_days = []
      r.man_days.map(m => {
        if (!startsWith(m.month, '-')) man_days.push(m)
        return null
      })
      resource.man_days = man_days
      resources.push(resource)
      return null
    })
    project.resources = resources
    auto_fill_payload.project_state = project
    const autoFillManDays = get(this.props, 'autoFillManDays')
    autoFillManDays(auto_fill_payload)
    this.setState({ showAutoAdd: !this.state.showAutoAdd })
  }

  confirmEditResourceCost = async () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    const projectByID = this.state.projectByID
    const payload = { ...projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    if (projectByID.project_type === CONSTANTS.SUPPORT) {
      payload.override_total_resource_mandays = parseFloat(this.state.override_total_resource_mandays)
      payload.override_avg_resource_man_day_rate = parseFloat(this.state.override_avg_resource_man_day_rate)
      payload.override_total_resource_cost = parseFloat(this.state.override_total_resource_cost)
      payload.override_total_resource_price = parseFloat(this.state.override_total_resource_price)
    }
    payload.resources = this.state.resources
    await editProjectInformation(payload, true)
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
    this.props.setIsEdit(false)
  }

  clickAddResource = (type) => {
    if (type === 'Employee') {
      this.setState({
        showAddEmployee: !this.state.showAddEmployee,
        resource_user_id: [],
        resource_search: '',
      })
    } else if (type === 'Subcontract') {
      this.setState({
        showAddSubCon: !this.state.showAddSubCon,
        resource_user_id: [],
        resource_search: '',
      })
    } else {
      this.setState({
        showAddEmployee: false,
        showAddSubCon: false,
        resource_user_id: [],
        resource_search: '',
      })
    }
  }

  addResource = () => {
    const startDate = get(this.state.projectByID, 'start_date')
    const endDate = get(this.state.projectByID, 'end_date')
    const employees = get(this.props, 'employees')
    const oldResources = clone(this.state.resources)
    let resources = []
    this.state.resource_user_id.map(id => {
      const user = find(employees, { _id: id })
      if (user) {
        const resource = {}
        resource.user_id = user._id
        resource.role = ''
        resource.type = user.employee_type
        resource.cost_rate = 0
        resource.price_rate = 0
        let start_date = startDate
        const months = []
        if (start_date !== '' && endDate !== '') {
          while (moment(start_date).isSameOrBefore(moment(endDate), 'month')) {
            months.push({ month: `${moment(start_date).format('YYYY')}-${moment(start_date).format('MM')}`, days: 0 })
            start_date = moment(start_date).add(1, 'month')
          }
        }
        resource.man_days = months
        resources.push(resource)
      }
      return id
    })
    resources = [...oldResources, ...resources]
    this.setState({
      resource_search: '',
      resources,
    })
    this.clickAddResource()
  }

  handleAutoAdd = () => {
    this.setState({
      showAutoAdd: !this.state.showAutoAdd,
      auto_fill_man_days: [],
      auto_fill_search: '',
      auto_fill_start_date: moment(this.state.auto_fill_start_date),
      auto_fill_end_date: moment(this.state.auto_fill_end_date),
      maximum_working_day: true,
      specific_working_day: false,
      working_day: 0,
    })
  }

  handleChangeCostResource = (e, id, month_key) => {
    const newResources = clone(this.state.resources)
    const resource = find(this.state.resources, { user_id: id })
    const field = e.target.name
    if (field === 'man_days') {
      const res = resource[field][month_key]
      res.days = parseFloat(e.target.value)
      resource[field][month_key] = res
    } else {
      resource[field] = e.target.value
    }
    const index = findIndex(this.state.resources, { user_id: id })
    newResources[index] = resource
    this.setState({ resources: newResources })
  }

  handleInput = (e) => {
    if (e.target.type === 'checkbox') {
      if (e.target.name === 'addResource') {
        const resource_user_id = this.state.resource_user_id
        const idx = resource_user_id.indexOf(e.target.value)
        if (idx < 0) {
          this.setState({ resource_user_id: [...resource_user_id, e.target.value] })
        } else {
          resource_user_id.splice(idx, 1)
          this.setState({ resource_user_id })
        }
      } else {
        const auto_fill_man_days = this.state.auto_fill_man_days
        const idx = auto_fill_man_days.indexOf(e.target.value)
        if (idx < 0) {
          this.setState({ auto_fill_man_days: [...auto_fill_man_days, e.target.value] })
        } else {
          auto_fill_man_days.splice(idx, 1)
          this.setState({ auto_fill_man_days })
        }
      }
    } else if (e.target.type === 'radio') {
      this.setState({
        specific_working_day: e.target.id === 'specific_working_day',
        maximum_working_day: e.target.id === 'maximum_working_day',
      })
    } else this.setState({ [e.target.name]: e.target.value })
  }

  deleteResource = (id) => {
    const resources = clone(this.state.resources)
    const index = findIndex(resources, { user_id: id })
    resources.splice(index, 1)
    this.setState({ resources })
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const { hideHeader } = this.props
    const getProjectInformationByID = get(this.props, 'getProjectInformationByID')
    const clickEditResource = get(this.props, 'clickEditResource')
    return (
      <div style={ { background: '#FFFFFF' } }>
        <AddResourceForm
          open={ this.state.showAddEmployee || this.state.showAddSubCon }
          toggle={ () => this.clickAddResource() }
          type={ this.state.showAddEmployee ? 'Employee' : 'Subcontract' }
          button={ addButton('addResource', () => this.addResource(), () => this.clickAddResource(), this.state.resource_user_id.length === 0) }
          handleInput={ this.handleInput }
          resources={ this.state.resources }
          resource_user_id={ this.state.resource_user_id }
          resource_search={ this.state.resource_search }
          employees={ get(this.props, 'employees') }
          handleSearch={ (e) => { this.setState({ resource_search: e }) } }
          handleClickAll={
            (resources) => {
              const array_user_id = []
              resources.forEach(r => { array_user_id.push(r._id) })
              this.setState({ resource_user_id: array_user_id })
            }
          }
          handleClickNone={ () => this.setState({ resource_user_id: [] }) }
        />
        <AutoFillManDaysForm
          open={ this.state.showAutoAdd }
          resources={ this.state.resources }
          employees={ get(this.props, 'employees') }
          auto_fill_man_days={ this.state.auto_fill_man_days }
          auto_fill_start_date={ this.state.auto_fill_start_date }
          auto_fill_end_date={ this.state.auto_fill_end_date }
          auto_fill_search={ this.state.auto_fill_search }
          working_day={ this.state.working_day }
          specific_working_day={ this.state.specific_working_day }
          maximum_working_day={ this.state.maximum_working_day }
          toggle={ () => this.setState({ showAutoAdd: !this.state.showAutoAdd }) }
          button={ addButton(
            'autoFillManDays',
            () => this.autoFillMandays(),
            () => this.setState({ showAutoAdd: !this.state.showAutoAdd }),
            this.state.auto_fill_man_days.length === 0)
          }
          handleInput={ this.handleInput }
          handleChangeStartDate={ (e) => this.setState({ auto_fill_start_date: e }) }
          handleChangeEndDate={ (e) => this.setState({ auto_fill_end_date: e }) }
          handleSearch={ (e) => this.setState({ auto_fill_search: e }) }
          handleClickNone={ () => this.setState({ auto_fill_man_days: [] }) }
          handleClickAll={
            () => {
              const array_user_id = []
              const resources = this.state.resources
              resources.forEach(r => { array_user_id.push(r.user_id) })
              this.setState({ auto_fill_man_days: array_user_id })
            }
          }
        />
        <ConfirmSaveForm
          open={ this.state.showConfirmSave }
          toggle={ () => this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          confirmSave={ this.confirmEditResourceCost }
        />
        <Searchbar
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          hide={ this.state.hide }
          override_total_resource_mandays={ this.state.override_total_resource_mandays }
          override_avg_resource_man_day_rate={ this.state.override_avg_resource_man_day_rate }
          override_total_resource_cost={ this.state.override_total_resource_cost }
          override_total_resource_price={ this.state.override_total_resource_price }
          handleInput={ this.handleInput }
          editResource={ this.state.editResource }
          hideInfo={ (e) => this.setState({ hide: e }) }
          handleSearch={ (e) => this.setState({ search_resource: e }) }
          handleFilterLOB={ (e) => this.setState({ filter_lob: e }) }
          handleFilterModule={ (e) => this.setState({ filter_module: e }) }
          lobOptions={ uniqBy(get(this.state, 'resources', []), 'lob') }
          moduleOptions={ filter(uniqBy(get(this.state, 'resources', []), 'module'), r => r.module) }
          clickCalculate={ this.clickCalculate }
          clickEdit={ () => clickEditResource() }
          clickAddResource={ this.clickAddResource }
          editResourceCost={ this.editResourceCost }
          handleAutoAdd={ this.handleAutoAdd }
          cancelEdit={ () => {
            clickEditResource()
            this.setState({ projectByID: null })
            getProjectInformationByID()
          } }
        />
        <ResourceCostTable
          hideHeader={ hideHeader }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          hide={ this.state.hide }
          search_resource={ this.state.search_resource }
          filter_lob={ this.state.filter_lob }
          filter_module={ this.state.filter_module }
          resources={ this.state.resources }
          $resource_cost={ this.state.$resource_cost }
          $work_days={ this.state.$work_days }
          employees={ get(this.props, 'employees') }
          editResource={ this.state.editResource }
          handleChangeCostResource={ this.handleChangeCostResource }
          deleteResource={ this.deleteResource }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-resource-cost.js